import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slice/authSlice';
import meReducer from '../slice/meSlice';
import userReducer from '../slice/userSlice';
import roleReducer from '../slice/roleSlice';
import permissionReducer from '../slice/permissionSlice';
import testDriveReducer from '../slice/testDriveSlice';
import leadReducer from '../slice/leadSlice';
import customerReducer from '../slice/customerSlice';
import serviceBookingGrReducer from '../slice/serviceBookingGrSlice';
import serviceBookingBpReducer from '../slice/serviceBookingBpSlice';
import appraisalBookingReducer from '../slice/appraisalSlice';
import trackOrderStatusReducer from '../slice/trackOrderStatusSlice';
import serviceJobReducer from '../slice/serviceJobSlice';
import oneAccountReducer from '../slice/oneAccountSlice';
import customerActivityReducer from '../slice/customerActivitySlice';
import vehicleReducer from '../slice/vehicleSlice';
import submitDecReducer from '../slice/submitDecSlice';
import financeReducer from '../slice/financeSimulationSlice';
import getOfferReducer from '../slice/getOfferSlice';
import additionalJobReducer from '../slice/additionalJobSlice';
import customerRemindersReducer from '../slice/customerRemindersSlice';

const store = configureStore({
    reducer: {
        auth: authReducer,
        me: meReducer,
        users: userReducer,
        roles: roleReducer,
        permissions: permissionReducer,
        testDrive: testDriveReducer,
        leads: leadReducer,
        customer: customerReducer,
        financeSimulation: financeReducer,
        serviceBookingGr: serviceBookingGrReducer, 
        serviceBookingBp: serviceBookingBpReducer, 
        appraisalBooking: appraisalBookingReducer,
        serviceJob: serviceJobReducer,
        oneAccount: oneAccountReducer,
        customerActivity: customerActivityReducer,
        vehicle: vehicleReducer,
        trackOrderStatus: trackOrderStatusReducer,
        getOffer: getOfferReducer,
        submitDec: submitDecReducer,
        additionalJob: additionalJobReducer,
        customerReminders: customerRemindersReducer,
    },
});

export default store;